import React from "react";
import PropTypes from "prop-types";
import clsx from "clsx";
import { Typography } from "@material-ui/core";
import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline";
import useStyles from "./FormShell.styles";
import { ErrorItemShape } from "./formShell.propTypes";

// Keep byte-identical: host tests match on this string.
const defaultTitle = (n) =>
  `${n} ${n === 1 ? "field needs" : "fields need"} attention`;

const itemTitle = (item) =>
  item.message ? `${item.label}: ${item.message}` : item.label;

/** "N fields need attention" banner (markup from Add_Loan). */
function FormErrorSummary({ items, onItemClick, title, className }) {
  const classes = useStyles();
  if (!items || items.length === 0) return null;

  return (
    <div role="alert" className={clsx(classes.errorSummaryBanner, className)}>
      <ErrorOutlineIcon className={classes.errorSummaryIcon} />
      <div className={classes.errorSummaryContent}>
        <Typography className={classes.errorSummaryTitle}>
          {title || defaultTitle(items.length)}
        </Typography>
        <div className={classes.errorSummaryList}>
          {items.map((item) =>
            item.fieldId ? (
              <button
                type="button"
                key={item.key}
                className={classes.errorSummaryItem}
                title={itemTitle(item)}
                onClick={() => onItemClick && onItemClick(item)}
              >
                {item.label}
              </button>
            ) : (
              <span
                key={item.key}
                className={clsx(
                  classes.errorSummaryItem,
                  classes.errorSummaryItemStatic
                )}
                title={itemTitle(item)}
              >
                {item.label}
              </span>
            )
          )}
        </div>
      </div>
    </div>
  );
}

FormErrorSummary.propTypes = {
  items: PropTypes.arrayOf(ErrorItemShape).isRequired,
  // Called only for items with a fieldId.
  onItemClick: PropTypes.func,
  title: PropTypes.string,
  className: PropTypes.string,
};

export default FormErrorSummary;
